import type {
  IGlobalSearchResponse,
  ISearchGlobalParams,
} from "../types/global-search";
import type { ApiClient } from "./client";

export class GlobalSearchApi {
  constructor(private apiClient: ApiClient) {}

  async search({
    query,
    limit,
  }: ISearchGlobalParams): Promise<IGlobalSearchResponse> {
    const response = await this.apiClient.get<IGlobalSearchResponse>(
      "/search/global",
      { params: { q: query, ...(limit === undefined ? {} : { limit }) } },
    );
    return response.data;
  }
}
